module.exports = __webpack_public_path__ + "media/images/newbies-rocket-ac527219cb3759a25062213f54b7e0f0.webp";